import {Observable, Subscription} from 'rxjs';

import IPlaybackStore from '../Interfaces/IPlaybackStore';

const subscribeToConsumerTogglePlayPause = (
    consumerTogglePlayPause$: Observable<boolean>,
    playbackStore: IPlaybackStore
): Subscription =>
    consumerTogglePlayPause$
        .subscribe((shouldPlay: boolean) => shouldPlay ?
            playbackStore.actions.play() :
            playbackStore.actions.pause()
        );

export default subscribeToConsumerTogglePlayPause;